import React from "react";
import AssessmentImg from "../../../assets/Assessment-1.png";
import AssessmentImg2 from "../../../assets/Assessment-2.png";
import AssessmentImg3 from "../../../assets/Assessment-3.png";
import AssessmentImg4 from "../../../assets/Assessment-4.png";
import { AssessmentCard } from "./AssessmentCard";
import { AssessmentArtical } from "./AssessmentArtical";
import "./MainContent.css";
import { MainHeader } from "../../chatMain/MainHeader/MainHeader";

export const MainContentAssessment = () => {
  return (
    <div className="mainarea-assessment">
      <div className="main">
        <div className="assessment">
          <p className="blog-article-title" style={{alignSelf:"flex-start"}}>
            Well-Being Assessments
          </p>
          <p className="blog-article-description" style={{alignSelf:"flex-start", paddingBottom:"0.5rem"}}> 
              Structured evaluations designed to measure various aspects of an your physical, mental, emotional, and social health.
          </p>
          <div className="blog-post-card">
            <AssessmentCard
              icon="🧠"
              title="  PEARLI™ Six domains of life scale"
              subtitle=" PEARLI™ assesses Six domains of life: Physical, Emotional, Acceptance, Relationships, Loving-kindness, Intellectual. "
              imgSrc={AssessmentImg2}
              link="/Disclaimer"
            />
          </div>

          <div className="blog-article-content">
            <div className="blog-article-session">
              <div className="blog-article-content1">
                <div className="subheading-container">
                  <p className="Subheading">Coming Soon</p>
                </div>
                <p className="blog-article-title">
                  Resilience & Personality Insights
                </p>
              </div>
              <p className="blog-article-description">
                Launching soon to help you understand your strengths under
                pressure.
              </p>
            </div>
            <div className="blog-post-card">
            <AssessmentArtical
              //icon="💼"
              title=" PEARLI™ -work and productivity scale"
              subtitle=" PEARLI™ assesses SUB SCALE at work and productivity"
              imgSrc={AssessmentImg}
              // link="/physical-assessment"
            />
              <AssessmentArtical
                // icon="💼"
                title="The Racial and Ethnic Microaggression Scale (R28-REMS)"
                subtitle="Examining the Factorial Structure for Black, Latino/Hispanic, and Asian Young Adults"
                imgSrc={AssessmentImg3}
              />

              <AssessmentArtical
                // icon="🧠"
                title="Myers-Briggs Type Indicator - MBTI"
                subtitle="Categorizes individuals into one of 16 personality types based on their preferences in four dimensions: extraversion/introversion, sensing/intuition, thinking/feeling, and judging/perceiving"
                imgSrc={AssessmentImg4}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
